export function formatDocumentNumber(nrDoc, docDate, oddzial) {
    if (!nrDoc || !docDate || !oddzial) return "";

    const date = new Date(docDate);
    const year = date.getFullYear().toString().substring(2, 4);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');

    return `${nrDoc}/${year}/${month}-${oddzial}`;
}
